/* ============
 * Mutation types for the exteriors module
 * ============
 *
 * The mutation types that are available
 * on the exteriors module.
 */

export const LOAD = 'LOAD';
export const TOGGLE_SHOW_OVERLAY_STATUS = 'TOGGLE_SHOW_OVERLAY_STATUS';
export const SET_POI_LIST = 'SET_POI_LIST';
export const TOGGLE_POI = 'TOGGLE_POI';
export const TOGGLE_POI_MASK = 'TOGGLE_POI_MASK';
export const SET_HOVERED_LINKED_VIEW_ID = 'SET_HOVERED_LINKED_VIEW_ID';

export default {
  LOAD,
  TOGGLE_SHOW_OVERLAY_STATUS,
  SET_POI_LIST,
  TOGGLE_POI,
  TOGGLE_POI_MASK,
  SET_HOVERED_LINKED_VIEW_ID,
};
